module.exports = __webpack_public_path__ + "img/logo-text.a63430af.png";